export const LOAD_OFFICES = 'LOAD_OFFICES'
export const LOAD_SOCIETY_OFFICES = 'LOAD_SOCIETY_OFFICES'
export const SET_SELECTED_COMPANY = 'SET_SELECTED_COMPANY'
export const LOAD_SOCIETY_EMPLOYEE = 'LOAD_SOCIETY_EMPLOYEE'

